import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useMutation, gql } from '@apollo/client'

import { Formik } from 'formik'
import * as yup from 'yup'

import { getUnprocessableErrors } from 'utils/error'
import { Button } from 'components/v2/Button'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { InputTags } from 'components/v2/InputTags'
import { schema } from './schema'

const messages = defineMessages({
  emailsPlaceholder: {
    id: 'bookings.resendEmails.placeholder',
    defaultMessage: 'Emails separated with comma'
  }
})

const SEND_TICKETS = gql`
  mutation SendTickets($bookingId: ID!, $emails: [String!]!) {
    sendTickets(input: { bookingID: $bookingId, emails: $emails })
  }
`

export const ResendEmailsModal = ({ booking, closeModal }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const schemaObject = schema(intl)

  const [resendEmails, { loading, error }] = useMutation(SEND_TICKETS, {
    onCompleted() {
      closeModal()
    }
  })

  const handleSubmit = (values: TSFixMe): TSFixMe => {
    resendEmails({
      variables: {
        bookingId: booking.id,
        emails: values.emails
      }
    })
  }

  const initialValues = {
    emails: [booking.buyer.email],
    email: ''
  }

  return (
    <Modal.Container>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage id="bookings.resendEmails.title" defaultMessage="Resend Emails" />
        </Heading.H5>
      </Modal.Header>

      <Formik initialValues={initialValues} validationSchema={schema(intl)} onSubmit={handleSubmit}>
        {(props): TSFixMe => {
          const { touched, errors, setFieldValue, setFieldTouched } = props
          const isValidEmail = (email: TSFixMe): TSFixMe => {
            return yup.reach(schemaObject, 'email').isValidSync(email)
          }

          const handleChange = (values: TSFixMe): TSFixMe => {
            if (values.length > 0) {
              const lastEmail = values[values.length - 1]

              if (!isValidEmail(lastEmail)) {
                setFieldTouched('email')
                return
              }
            }

            setFieldTouched('email', false)
            props.setFieldValue('emails', values)
          }

          const validateEmail = (value: TSFixMe): TSFixMe => {
            setFieldTouched('email', false)
            setFieldTouched('emails', false)
            setFieldValue('email', value)
          }

          return (
            <form onSubmit={props.handleSubmit}>
              <Modal.Content>
                <InputTags
                  values={props.values.emails}
                  onChange={handleChange}
                  placeholder={intl.formatMessage(messages.emailsPlaceholder)}
                  validate={validateEmail}
                  isValid={isValidEmail}
                />
                {touched.emails && errors.emails && !props.values.email && <ErrorMessage>{errors.emails}</ErrorMessage>}
                {touched.email && errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
              </Modal.Content>

              <Modal.Footer>
                {error && (
                  <Modal.ErrorMessage>
                    <ErrorMessage errors={getUnprocessableErrors(error)}>
                      <FormattedMessage
                        id="booking.resendEmails.error"
                        defaultMessage="There was an error while resending the emails"
                      />
                    </ErrorMessage>
                  </Modal.ErrorMessage>
                )}
                <Modal.Actions>
                  <Button kind="cancel" onClick={(): TSFixMe => closeModal()}>
                    <FormattedMessage id="dictionary.cancel" defaultMessage="Cancel" />
                  </Button>
                  <Button type="submit" kind="primary" loading={loading}>
                    <FormattedMessage id="booking.resendEmails.submit" defaultMessage="Send emails" />
                  </Button>
                </Modal.Actions>
              </Modal.Footer>
            </form>
          )
        }}
      </Formik>
    </Modal.Container>
  )
}
